import { useTranslation } from "react-i18next";
import { education } from "../data/education";

export default function Education() {
  const { t, i18n } = useTranslation('translation', { useSuspense: false });
  
  return (
    <section className="section">
      <h2>{t('title.education')}</h2>
      {education[i18n.language].map(edu => (
        <div key={edu.title}>
          <h3>{edu.degree} {t('title.in')} {edu.title}</h3>
          <p>{edu.institution} - {edu.period}</p>
        </div>
      ))}
    </section>
  );
}
